import { init } from './MallCPAZXItems';
init();
